let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kk1YF")).then(() => parcelRequire('eN97g'));